import { Box, Card, CardContent, Grid, Typography } from "@mui/material";
import React from "react";
import transporation from "../../../../assets/transporation.png";
import cctv from "../../../../assets/cctv.png";
import playarea from "../../../../assets/playarea.png";
import caretaker from "../../../../assets/caretaker.png";

const Facilities = () => {
  return (
    <Grid container  id="facilities" sx={{ p: { xs: 2, md: 10 } }}>
      <Grid item xs={12}>
        <Typography
          sx={{
            fontWeight:'bold',
            fontSize: { xs: 30, d: 50 },
            textAlign: "center",
            mt: { xs: 2, md: 0 },
          }}
        >
          Facilities
        </Typography>
      </Grid>

      <Grid
        container
        item
        sx={{ mt: 4, gap: { xs: 2, md: 0 }, ml: { xs: 2, md: 0 } }}
      >
        <Grid
          item
          xs={5}
          md={6}
          sx={{ display: "flex", justifyContent: "center" }}
        >
          <Card
            sx={{
              height: { xs: 200, md: 300 },
              boxShadow: 3,
              backgroundColor: "#1976d2",
              width: { x: 100, md: 500 },
              borderRadius: "0px 20px 20px 20px",
            }}
          >
            <CardContent>
              <Box
                sx={{
                  backgroundColor: "#fdc800",
                  width: 50,
                  height: 50,
                  mt: -2.5,
                  ml: -2,
                  borderRadius: "0px 0px 20px 0px",
                  display: { xs: "none", md: "block" },
                }}
              >
                <Typography
                  sx={{
                    fontSize: 30,
                    textAlign: "center",
                    mt: 0.5,
                    color: "#fff",
                  }}
                >
                  1
                </Typography>
              </Box>
              <Typography
                sx={{
                  fontSize: { xs: 15, md: 30 },
                  fontWeight: "bold",
                  textAlign: "center",
                  color: "#fff",
                  mt: { xs: 0, md: -4 },
                }}
              >
                Free Transportation
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", md: "row" },
                  justifyContent: "center",
                  alignItems: "center",
                  mt: { xs: 0, md: 4 },
                }}
              >
                <img
                  src={transporation}
                  alt="Transportation"
                  style={{
                    width: "150px",
                    maxWidth: "100%",
                  }}
                />

                <Box sx={{ mt: {xs:4,d:2}, ml: 2, color: "#fff" }}>
                  <ul style={{ paddingLeft: "20px", margin: 0 }}>
                    <li>
                      <Typography>
                        Safe and hassle-free commute for all students at no
                        cost.
                      </Typography>
                    </li>
                    <li>
                      <Typography>
                        Well-equipped buses with trained staff for supervision.
                      </Typography>
                    </li>
                    <li>
                      <Typography>
                        Ensures convenience for parents while prioritizing child
                        safety.
                      </Typography>
                    </li>
                  </ul>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
        <Grid
          item
          xs={5}
          md={6}
          sx={{ display: "flex", justifyContent: "center" }}
        >
          <Card
            sx={{
              height: { xs: 200, md: 300 },
              position: "relative",
              boxShadow: 3,
              backgroundColor: "#1976d2",
              width: 500,
              borderRadius: "20px 0px 20px 20px",
            }}
          >
            <CardContent>
              <Box
                sx={{
                  backgroundColor: "#fdc800",
                  width: 50,
                  height: 50,
                  mt: -2.5,
                  ml: 54.5,
                  borderRadius: "0px 0px 0px 20px",
                  display: { xs: "none", md: "block" },
                }}
              >
                <Typography
                  sx={{
                    fontSize: 30,
                    textAlign: "center",
                    mt: 0.5,
                    color: "#fff",
                  }}
                >
                  2
                </Typography>
              </Box>
              <Typography
                sx={{
                  fontSize: { xs: 15, md: 30 },
                  fontWeight: "bold",
                  textAlign: "center",
                  color: "#fff",
                  mt: { xs: 0, md: -4 },
                }}
              >
                Live CCTV Access
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", md: "row" },
                  justifyContent: "center",
                  alignItems: "center",
                  mt: { xs: 2, md: 4 },
                }}
              >
                <img src={cctv} alt="Transportation"  style={{
                    width: "120px",
                    maxWidth: "80%",
                  }} />
                <Box sx={{ mt: {xs:5,md:2}, ml: 2, color: "#fff" }}>
                  <ul style={{ paddingLeft: "20px", margin: 0 }}>
                    <li>
                      <Typography>
                        Real-time monitoring for parents to ensure transparency
                        and security.
                      </Typography>
                    </li>
                    <li>
                      <Typography>
                        Strengthens trust between parents and the school.
                      </Typography>
                    </li>
                    <li>
                      <Typography>
                        Provides a safer learning environment for children.
                      </Typography>
                    </li>
                  </ul>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      <Grid
        item
        xs={12}
        sx={{
          display: "flex",
          justifyContent: "center",
          mt: -6,
          mb: -6,
        }}
      >
        <Box
          sx={{
            width: { xs: 100, md: 200 },
            height: { xs: 100, md: 200 },
            backgroundColor: "#fdc800",
            borderRadius: "50%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: "#fff",
            boxShadow: 3,
            animation: "zoomInOut 2s ease-in-out infinite",
            "@keyframes zoomInOut": {
              "0%": { transform: "scale(1)" },
              "50%": { transform: "scale(1.15)" },
              "100%": { transform: "scale(1)" },
            },
            pointerEvents: "none",
          }}
        >
          <Typography sx={{ fontSize: { xs: 15, md: 30 }, fontWeight: "bold" }}>
            Facilities
          </Typography>
        </Box>
      </Grid>

      <Grid
        container
        item
        xs={12}
        sx={{ mt: -5, gap: { xs: 2, md: 0 }, ml: { xs: 2, md: 0 } }}
      >
        <Grid
          item
          xs={5}
          md={6}
          sx={{
            display: "flex",
            justifyContent: "center",
            mt: { xs: 8, md: 0 },
          }}
        >
          <Card
            sx={{
              height: { xs: 200, md: 300 },
              boxShadow: 3,
              backgroundColor: "#1976d2",
              width: { xs: "100%", md: 500 },
              borderRadius: "0px 20px 20px 20px",
            }}
          >
            <CardContent>
              <Box
                sx={{
                  backgroundColor: "#fdc800",
                  width: 50,
                  height: 50,
                  mt: -2.5,
                  ml: -2,
                  borderRadius: "0px 0px 20px 0px",
                  display: { xs: "none", md: "block" },
                }}
              >
                <Typography
                  sx={{
                    fontSize: 30,
                    textAlign: "center",
                    mt: 0.5,
                    color: "#fff",
                  }}
                >
                  3
                </Typography>
              </Box>
              <Typography
                sx={{
                  fontSize: { xs: 15, md: 30 },
                  fontWeight: "bold",
                  textAlign: "center",
                  color: "#fff",
                  mt: { xs: 0, md: -4 },
                }}
              >
                Play Area
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", md: "row" },
                  justifyContent: "center",
                  alignItems: "center",
                  mt: { xs: 1, md: 4 },
                }}
              >
                <img
                  src={playarea}
                  alt="Transportation"
                  style={{ width: 150 }}
                />
                <Box sx={{ mt: 2, ml: 2, color: "#fff" }}>
                  <ul style={{ paddingLeft: "20px", margin: 0 }}>
                    <li>
                      <Typography>
                        Safe and spacious play area designed for fun and
                        physical development.
                      </Typography>
                    </li>
                    <li>
                      <Typography>
                        Encourages social interaction, teamwork, and creativity.
                      </Typography>
                    </li>
                    <li>
                      <Typography>
                        Helps improve motor skills, coordination, and overall
                        well-being.
                      </Typography>
                    </li>
                  </ul>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
        <Grid
          item
          xs={5}
          md={6}
          sx={{
            display: "flex",
            justifyContent: "center",
            color: "#fff",
            mt: { xs: 8, md: 0 },
          }}
        >
          <Card
            sx={{
              height: { xs: 200, md: 300 },
              boxShadow: 3,
              backgroundColor: "#1976d2",
              width: 500,
              borderRadius: "20px 0px 20px 20px",
            }}
          >
            <CardContent>
              <Box
                sx={{
                  backgroundColor: "#fdc800",
                  width: 50,
                  height: 50,
                  mt: -2.5,
                  ml: 54.5,
                  borderRadius: "0px 0px 0px 20px",
                  display: { xs: "none", md: "block" },
                }}
              >
                <Typography
                  sx={{
                    fontSize: 30,
                    textAlign: "center",
                    mt: 0.5,
                    color: "#fff",
                  }}
                >
                  2
                </Typography>
              </Box>

              <Typography
                sx={{
                  fontSize: { xs: 15, md: 30 },
                  fontWeight: "bold",
                  textAlign: "center",
                  color: "#fff",
                  mt: { xs: 0, md: -4 },
                }}
              >
                CareTakers
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", md: "row" },
                  justifyContent: "center",
                  alignItems: "center",
                  mt: { xs: 4, md: 4 },
                }}
              >
                <Box
                  component="img"
                  src={caretaker}
                  alt="CareTakers"
                  sx={{ width: { xs: 100, md: 150 } }}
                />
                <Box sx={{ mt: 3, ml: 2, color: "#fff" }}>
                  <ul style={{ paddingLeft: "20px", margin: 0 }}>
                    <li>
                      <Typography sx={{ fontSize: 16 }}>
                        Trained staff providing personalized care and attention.
                      </Typography>
                    </li>
                    <li>
                      <Typography sx={{ fontSize: 16 }}>
                        Ensure a nurturing and secure environment for children.
                      </Typography>
                    </li>
                    <li>
                      <Typography sx={{ fontSize: 16 }}>
                        Support emotional, social, and daily needs of each
                        child.
                      </Typography>
                    </li>
                  </ul>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Facilities;

